<template>
  <div class="perfotm-acelist">
    <h1 class="title">业绩榜单</h1>
    <div>
      <a-tabs default-active-key="3" @change="callback">
        <a-tab-pane key="3" tab="个人"> <Personal /> </a-tab-pane>
        <a-tab-pane key="2" tab="小组" force-render> <Group /> </a-tab-pane>
        <a-tab-pane key="1" tab="门店"> <StoreView/> </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>

<script>
import Personal from './model/personal.vue'
import Group from './model/group.vue'
import StoreView from './model/store.vue'
export default {
  name: 'AchievementPerformanceList',
  components: {
    Personal,
    Group,
    StoreView
  },
  data () {
    return {
      listType: '3'
    }
  },
  methods: {
    callback (key) {
      this.listType = key
      console.log(key)
    }
  }
}
</script>
<style>
.ant-table-body {
  overflow: auto;
}
</style>
<style lang="less" scoped>
.perfotm-acelist {
  height: 100%;
  border-radius: 15px;
  background-color: #fff;
  .title {
    padding: 20px 20px 0 20px;
    font-size: 20px;
    font-weight: 700;
  }
  div {
    /deep/.ant-tabs-nav {
      margin-left: 20px !important;
    }
  }
}

</style>
<style lang="less">
// .fix_top .ant-table-thead  {
//   width:calc( 100% - 173px );
//   position:fixed;
//   top:0px;
//   left:173px;
//   z-index:9999;
//   padding-top:10px;
//   background: #fff;
// }
// .fix_top .ant-table-thead tr{
//     width:100%;
//     display:inline-table;
//     th{
//       border:none;
//       width:150px;
//     }
//     th:nth-child(1){
//       border:none;
//       width:100px;
//     }
//     th:nth-child(2){
//       border:none;
//       width:100px;
//     }
//     th:nth-child(3){
//       border:none;
//       width:100px;
//     }
//     th:nth-child(4){
//       border:none;
//       width:100px;
//     }
//   }
</style>
